import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';

export function CreateUserDialog({ open, onClose, form, setForm, onSubmit, submitting }) {
  return (
    <Dialog open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent data-testid="create-user-dialog">
        <DialogHeader>
          <DialogTitle>{"Cr\u00e9er un compte"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label>Nom</Label>
            <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} data-testid="create-name" />
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="create-email" />
          </div>
          <div>
            <Label>Mot de passe</Label>
            <Input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} data-testid="create-password" />
          </div>
          <div>
            <Label>Plan</Label>
            <Select value={form.plan} onValueChange={v => setForm({...form, plan: v})}>
              <SelectTrigger data-testid="create-plan"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="STARTER">STARTER</SelectItem>
                <SelectItem value="PRO">PRO</SelectItem>
                <SelectItem value="PREMIUM">PREMIUM</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button onClick={onSubmit} disabled={submitting} data-testid="create-submit">
            {submitting ? "..." : "Cr\u00e9er"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
